<header class="main__content__header modal-header">
    <h2 class="modal-title">Solicitação de Edição dos Dados Pessoais</h2>
    <a class="header__btn__close" (click)="activeModal.close(true)">
        <span aria-hidden="true">X</span>
    </a>
</header>
<form [formGroup]="formGroup">
    <main class="main__content__modal modal-body">
        <blockquote class="main__content__modal__aviso">
            Para concluir a solicitação é necessário o upload dos arquivos que comprovem as informações fornecidas nos
            campos editados. E aceitar o termo de responsabilidade abaixo.
        </blockquote>
        <form-input [labelInput]="'Upload do arquivo(RG, CPF, Certidão de nascimento e/ou Certidão de casamento) '"
            [isRequired]="true" [tipoDocumento]="'file'" [formFiles]="formGroup.get('files.file')?.value"
            (adicionar)="adicionarArquivos($event)">
        </form-input>
        <div class="content-label-upload">
            <small>
                * São aceitos os formatos PDF, PNG e JPEG
            </small>
            <small>
                * Tamanho máximo: 25 MB
            </small>
        </div>
        <div class="mt-1" *ngFor="let itemFile of formGroup.get('files')?.value; let i = index">
            <div class="lista-row" [@fadeIn]>
                <span>
                    {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                </span>
                <div class="lista-actions">
                    <fa-icon class="card__header__icon lista-btn-close" size="2x" (click)="removeFile('files',i)"
                        [icon]="faSquareXmark"></fa-icon>
                </div>
            </div>
        </div>
        <section class="term">
            <h5>TERMO DE CIÊNCIA E RESPONSABILIDADE</h5>
            <p>1. O usuário está ciente que:</p>
            <ol class="termo-content">
                <li>
                    Ao utilizar o sistema, aceita todas as condições estabelecidas no presente termo, subordinando-se
                    integralmente às disposições nele previsto.
                </li>
                <li>
                    É responsável por manter a integralidade, confidencialidade e exatidão das suas informações, devendo
                    informar à Fundação Copel sempre que houver alguma alteração.
                </li>
                <li>
                    As alterações relacionadas aos documentos oficiais, estado civil e sexo, serão submetidas à análise
                    pela área de cadastro da Fundação Copel. Se os documentos anexados pelo usuário estiverem ilegíveis
                    ou não forem hábeis a comprovar a alteração, a solicitação será recusada. Neste caso, será remetido
                    um aviso para o usuário com o motivo da recusa.
                </li>
                <li>
                    As alterações de informações de contato, como celular e e-mail, só serão processadas após
                    confirmação do código de verificação enviado pela Fundação Copel.
                </li>
                <li>
                    Os dados informados no Portal de Atendimento serão inseridos às suas informações já cadastradas na
                    base de clientes da Fundação Copel e repassados aos Órgãos Reguladores. Podendo, ainda, ser
                    revelados em cumprimento à ordem judicial ou administrativa nesse sentido.
                </li>
                <li>
                    O uso inadequado do Portal de Atendimento, com a intenção de causar prejuízo ou lesão ao direito das
                    partes ou ao serviço administrativo, implicará em responsabilidade civil e criminal, além das
                    sanções processuais cabíveis e do imediato bloqueio de acesso.
                </li>
                <li>
                    Não caberá à Fundação Copel ser responsabilizada por eventuais prejuízos decorrentes da utilização
                    não autorizada por terceiros da informação cadastral do usuário ou decorrentes da divulgação
                    indevida, pelo usuário, de sua identificação eletrônica.
                </li>
                <li>
                    A fundação Copel utiliza cookies para controlar a navegação do site e poderá coletar informações
                    técnicas, tais como, tipo de navegador do computador utilizado para acesso ao site, endereço de
                    protocolo de Internet e tempo médio gasto no site. Tais informações serão utilizadas apenas para
                    fins estatísticos e para melhorar os serviços ofertados.
                </li>
            </ol>
            <p>2. O usuário se compromete:</p>
            <ol class="termo-content">
                <li>
                    Não revelar a senha de acesso ao sistema e tomar o máximo de cuidado para que ela permaneça em
                    sigilo.
                </li>
                <li>
                    Alterar a senha, sempre que obrigatório ou que tenha suposição de descoberta por terceiros, não
                    usando combinações simples que possam ser facilmente descobertas.
                </li>
                <li>
                    Notificar a Fundação Copel, imediatamente, a respeito de qualquer uso não autorizado de seu login e
                    senha.
                </li>
                <li>
                    Observar e cumprir as regras do presente Termo de Ciência e Responsabilidade.
                </li>
            </ol>
            <section class="content-artigo">
                <b>Art. 299 do Código Penal - Dos Crimes Contra a Fé Pública - Da Falsidade Documental - Falsidade
                    Ideológica:</b>
                omitir, em documento público ou particular, declaração que dele devia constar, ou nele inserir ou fazer
                inserir declaração falsa ou diversa da que devia ser escrita, com o fim de prejudicar direito, criar
                obrigação ou alterar a verdade sobre fato juridicamente relevante.
            </section>
        </section>
    </main>
    <footer class="main__content__footer modal-footer">
        <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="customcheckbox1" formControlName="acceptedterms">
            <label class="custom-control-label" for="customcheckbox1">Li e aceito o termo de responsabilidade.</label>
        </div>
        <button class="btn button-primary col-xl-3 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1"
            [disabled]="formGroup.invalid" (click)="onSubmit()">
            Solicitar alteração
        </button>
    </footer>
</form>